import { http } from '../http';

export class StruggleAPI {

    private static INSTANCE = new StruggleAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/nucleus/v2';


    public fetchStruggleList(subjectCode: string, params: any) {
        const endpoint = `${this.namespace}/taxonomy/subjects/${subjectCode}/struggles`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return response.data;
        });
    }
}

export const struggleAPI = StruggleAPI.instance;
